import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import languages from './languages';

const resources = Object.fromEntries(
  Object.entries(languages).map(([code, language]) => [
    code,
    {
      translation: language.translation,
    },
  ])
);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,

    fallbackLng: 'en',

    supportedLngs: Object.keys(languages),

    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'invex_language',
    },

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
